import { render, staticRenderFns } from "./privSchoolConstruction.vue?vue&type=template&id=380aba00&scoped=true&"
import script from "./privSchoolConstruction.vue?vue&type=script&lang=js&"
export * from "./privSchoolConstruction.vue?vue&type=script&lang=js&"
import style0 from "./privSchoolConstruction.vue?vue&type=style&index=0&id=380aba00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380aba00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
